import { useDispatch, useSelector } from 'react-redux';
import { StripInteractions } from '../../plot/components/StripInteractions';
import { useParentOnsetsSelector } from '../../scatter/selectors/scatter.selectors';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import { setEpisodeMeasurementTimestamp } from '../thunks/set-episode-measurement-timestamp.thunk';
import { startEpisodeMeasurement } from '../thunks/start-episode-measurement.thunk';
import { PropsWithChildren } from 'react';

export const EpisodeMeasurementContainer: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const dispatch = useDispatch();
  const isParentView = useSelector(useParentOnsetsSelector);
  const isEpisodeMeasurementActive = useSelector(
    isToolActiveSelector(Tool.episodeMeasurement),
  );

  const handler = (eventType: keyof WindowEventMap, timestamp: number) => {
    switch (eventType) {
      case 'mousemove':
        dispatch(setEpisodeMeasurementTimestamp(timestamp));
        break;

      case 'mousedown':
        dispatch(startEpisodeMeasurement(timestamp));
        break;
    }
  };

  if (!isEpisodeMeasurementActive || isParentView) {
    return <></>;
  }

  return (
    <StripInteractions eventHandler={handler}>{children}</StripInteractions>
  );
};
